export const analyticsFormatType = {
  Standard: "assured",
  ElectricHybrid: "ev_hybrid",
  EssentialChecks: "essential",
  FullInspection: "128",
  NoReport: "none",
};
